export function getColorVar(color: string): string {
  return `var(--${color})`;
}
